
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aca",
      function () {
        return require("private-next-pages/aca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aca"])
      });
    }
  